import api from 'services/api';

/**
 * DELETE `/zones/:name`. Resolves on success; throws on HTTP error (the backend
 * 409s if the zone still has queues/triggers, which the caller surfaces). The
 * 200 body is a `{ message }` acknowledgement with nothing to validate.
 */
export const deleteZone = async (name: string): Promise<void> => {
  await api.delete(`/zones/${encodeURIComponent(name)}`);
};
